const lang = {
    en: require('./en.json'),
    zh: require('./zh.json')
}

export default lang